import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, ChevronDown, Accessibility, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 z-50 flex flex-col items-center w-full" data-id="element-503">
      {/* Top Utility Bar */}
      <div className="w-full bg-navy-deep text-xs font-medium text-white/90 py-2 px-4 md:px-8 flex justify-between items-center" data-id="element-504">
        <div className="hidden md:flex items-center space-x-6" data-id="element-505">
          <div className="group relative cursor-pointer flex items-center hover:text-white transition-colors" data-id="element-506">
            Portals <ChevronDown className="w-3 h-3 ml-1" data-id="element-507" />
            <div className="absolute top-full left-0 mt-2 w-40 bg-white border border-slate-200 shadow-md rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 flex flex-col py-2 text-slate-700" data-id="element-508">
              <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy transition-colors" data-id="element-509">
                Student Portal
              </a>
              <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy transition-colors" data-id="element-510">
                Faculty Portal
              </a>
              <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy transition-colors" data-id="element-511">
                Staff Portal
              </a>
              <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy transition-colors" data-id="element-512">
                Alumni Network
              </a>
            </div>
          </div>
          <a href="#" className="hover:text-white transition-colors" data-id="element-513">
            Degree Verification
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-514">
            Career / Vacancies
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-515">
            Library
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-516">
            Contact Directory
          </a>
        </div>
        <div className="flex items-center space-x-4 ml-auto" data-id="element-517">
          <button className="hover:text-white transition-colors" aria-label="Toggle High Contrast" data-id="element-518">
            <Accessibility className="w-4 h-4" data-id="element-519" />
          </button>
          <div className="relative hidden sm:block" data-id="element-520">
            <Search className="w-3 h-3 absolute left-2.5 top-1/2 -translate-y-1/2 text-white/50" data-id="element-521" />
            <input type="text" placeholder="Search EWU..." className="bg-white/10 border border-white/20 rounded-full py-1 pl-8 pr-3 text-xs focus:outline-none focus:border-white/50 focus:bg-white/20 transition-all w-48 placeholder:text-white/50 text-white" data-id="element-522" />
          </div>
        </div>
      </div>

      {/* Primary Navigation */}
      <div className="w-full max-w-7xl px-4 mt-4" data-id="element-523">
        <nav className="bg-white border border-slate-200 rounded-2xl px-6 py-4 flex shadow-md flex-row items-center justify-between" data-id="element-524">
          <Link to="/" className="flex items-center group" aria-label="East West University Home" data-id="element-525">
            <div className="bg-white rounded-lg px-3 py-2 shadow-sm group-hover:shadow-md transition-shadow" data-id="element-526">
              <img src="https://cdn.magicpatterns.com/uploads/b1kcBeF9jP1wXprpSnfWGK/image_30.png" alt="East West University" className="h-8 md:h-9 w-auto object-contain" data-id="element-527" />
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-1" data-id="element-528">
            <NavDropdown title="About EWU" data-id="element-529">
              <div className="grid grid-cols-2 gap-4 w-[400px] p-4 text-slate-700" data-id="element-530">
                <div className="flex flex-col space-y-2" data-id="element-531">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-532">
                    Institution
                  </span>
                  <a href="#" className="text-sm hover:text-navy transition-colors" data-id="element-533">
                    Board of Trustees
                  </a>
                  <a href="#" className="text-sm hover:text-navy transition-colors" data-id="element-534">
                    VC's Message
                  </a>
                  <a href="#" className="text-sm hover:text-navy transition-colors" data-id="element-535">
                    IQAC
                  </a>
                </div>
                <div className="flex flex-col space-y-2" data-id="element-536">
                  <span className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-537">
                    Discover
                  </span>
                  <a href="#" className="text-sm hover:text-navy transition-colors" data-id="element-538">
                    Campus Gallery
                  </a>
                  <a href="#" className="text-sm hover:text-navy transition-colors" data-id="element-539">
                    History & Mission
                  </a>
                </div>
              </div>
            </NavDropdown>

            <NavDropdown title="Academics" data-id="element-540">
              <div className="flex flex-col w-[280px] p-2 text-slate-700" data-id="element-541">
                <Link to="/department/cse" className="px-4 py-3 hover:bg-slate-50 rounded-lg transition-colors group" data-id="element-542">
                  <div className="font-medium group-hover:text-navy transition-colors" data-id="element-543">
                    Faculties & Departments
                  </div>
                  <div className="text-xs text-slate-500 mt-1" data-id="element-544">
                    Explore our 3 main faculties
                  </div>
                </Link>
                <Link to="/academic-calendar" className="px-4 py-3 hover:bg-slate-50 rounded-lg transition-colors group" data-id="element-545">
                  <div className="font-medium group-hover:text-navy transition-colors" data-id="element-546">
                    Academic Calendar
                  </div>
                  <div className="text-xs text-slate-500 mt-1" data-id="element-547">
                    Schedules, exams & deadlines
                  </div>
                </Link>
                <Link to="/faculty/profile" className="px-4 py-3 hover:bg-slate-50 rounded-lg transition-colors group" data-id="element-548">
                  <div className="font-medium group-hover:text-navy transition-colors" data-id="element-549">
                    Faculty Directory
                  </div>
                  <div className="text-xs text-slate-500 mt-1" data-id="element-550">
                    Meet our distinguished scholars
                  </div>
                </Link>
                <Link to="/faculty/cv-generator" className="px-4 py-3 hover:bg-slate-50 rounded-lg transition-colors group" data-id="element-551">
                  <div className="font-medium group-hover:text-navy transition-colors" data-id="element-552">
                    Faculty CV Generator
                  </div>
                  <div className="text-xs text-slate-500 mt-1" data-id="element-553">
                    Build & download your CV
                  </div>
                </Link>
              </div>
            </NavDropdown>

            <NavDropdown title="Admission" data-id="element-554">
              <div className="flex flex-col w-[240px] p-2 text-slate-700" data-id="element-555">
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-556">
                  Requirements
                </a>
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-557">
                  Tuition & Fees
                </a>
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-gold rounded-lg transition-colors text-gold font-medium" data-id="element-558">
                  Scholarships
                </a>
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-559">
                  Dates & Deadlines
                </a>
              </div>
            </NavDropdown>

            <NavDropdown title="Research" data-id="element-560">
              <div className="flex flex-col w-[260px] p-2 text-slate-700" data-id="element-561">
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-562">
                  Center for Research (CRT)
                </a>
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-563">
                  Journals & Publications
                </a>
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-564">
                  Ongoing Projects
                </a>
              </div>
            </NavDropdown>

            <NavDropdown title="Campus Life" data-id="element-565">
              <div className="flex flex-col w-[240px] p-2 text-slate-700" data-id="element-566">
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-567">
                  Student Welfare
                </a>
                <Link to="/clubs/programming" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-568">
                  Clubs & Activities
                </Link>
                <a href="#" className="px-4 py-2 hover:bg-slate-50 hover:text-navy rounded-lg transition-colors" data-id="element-569">
                  Medical Center
                </a>
              </div>
            </NavDropdown>
          </div>

          <div className="flex items-center space-x-4" data-id="element-570">
            <button className="hidden lg:block bg-gold hover:bg-gold-hover text-white font-bold py-2.5 px-6 rounded-xl transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-571">
              Apply Online
            </button>
            <button className="lg:hidden text-slate-700 p-2 hover:bg-slate-100 rounded-lg transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-572">
              {isMobileMenuOpen ? <X data-id="element-573" /> : <Menu data-id="element-574" />}
            </button>
          </div>
        </nav>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-575">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 w-full px-4 mt-2 lg:hidden" data-id="element-576">
            <div className="bg-white border border-slate-200 rounded-2xl p-4 flex flex-col space-y-2 shadow-xl text-slate-800" data-id="element-577">
              <Link to="/" className="p-3 font-medium hover:bg-slate-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-578">
                Home
              </Link>
              <Link to="/department/cse" className="p-3 font-medium hover:bg-slate-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-579">
                Academics (CSE)
              </Link>
              <Link to="/academic-calendar" className="p-3 font-medium hover:bg-slate-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-580">
                Calendar
              </Link>
              <Link to="/faculty/profile" className="p-3 font-medium hover:bg-slate-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-581">
                Faculty
              </Link>
              <Link to="/clubs/programming" className="p-3 font-medium hover:bg-slate-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-582">
                Clubs
              </Link>
              <button className="w-full mt-4 bg-gold text-white font-bold py-3 rounded-xl shadow-sm" data-id="element-583">
                Apply Online
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}
function NavDropdown({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="group relative px-3 py-2 cursor-pointer" data-id="element-584">
      <div className="flex items-center space-x-1 font-medium text-sm text-slate-700 group-hover:text-navy transition-colors" data-id="element-585">
        <span data-id="element-586">{title}</span>
        <ChevronDown className="w-3 h-3 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-587" />
      </div>
      <div className="absolute top-full left-1/2 -translate-x-1/2 pt-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50" data-id="element-588">
        <div className="bg-white border border-slate-200 rounded-2xl shadow-xl overflow-hidden relative" data-id="element-589">
          <div className="relative z-10" data-id="element-590">{children}</div>
        </div>
      </div>
    </div>;
}